import React from 'react';

import { marked } from 'marked';

import { Box, BoxProps } from '@mui/material';

type Props = {
  content: string;
  boxProps?: BoxProps;
};

export default function MarkdownPreview({ content, ...boxProps }: Props) {
  return <Box dangerouslySetInnerHTML={{ __html: marked.parse(content) }} {...boxProps} />;
}
